export default {"src":"/_next/static/media/latraise.807a5be0.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};